import React from "react";
import { Controller, FieldValues, UseControllerProps } from "react-hook-form";
import {
  DatePicker as MuiDatePicker,
  LocalizationProvider,
  CalendarPickerView,
} from "@mui/x-date-pickers";
import { endOfDay, parseISO } from "date-fns";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { CustomTextField, renderPickerDays } from "./CustomPicker";

interface Props<T extends FieldValues> extends UseControllerProps<T> {
  label: string;
  onChange: (value: Date | null) => void;
  pickerDays: Interval;
  minDate?: Date;
  maxDate?: Date;
  disablePast?: boolean;
  views?: CalendarPickerView[];
}

export const ControlledRangePicker = <T extends FieldValues>({
  name,
  label,
  control,
  onChange,
  pickerDays: { start, end },
  minDate,
  maxDate,
  disablePast,
  views,
}: Props<T>) => (
  <LocalizationProvider dateAdapter={AdapterDateFns}>
    <Controller
      name={name}
      control={control}
      render={({ field: { value } }) => (
        <MuiDatePicker
          label={label}
          value={endOfDay(parseISO(value as string))}
          onChange={onChange}
          renderDay={renderPickerDays({ start, end })}
          views={views}
          renderInput={(params) => (
            <CustomTextField
              {...params}
              variant="outlined"
              inputProps={{ ...params.inputProps, readOnly: true }}
              InputLabelProps={{ shrink: true }}
              margin="dense"
              size="small"
            />
          )}
          inputFormat="do MMM"
          minDate={minDate}
          maxDate={maxDate}
          showDaysOutsideCurrentMonth
          disableMaskedInput
          disablePast={disablePast}
        />
      )}
    />
  </LocalizationProvider>
);
